import { Model } from 'es6/components/model'
import { entryScriptName } from 'init/entry-script-name'
import { setCookie } from 'helpers/cookie-helper'
import { getFormattedPhoneNumber } from 'helpers/tel-helpers'
import { globalValidationError } from 'helpers/error-helper'
import isFunction from 'lodash/isFunction'
import moment from 'moment'
import { Defaults } from 'es-decorators'

/**
 * Модель для пользователя
 */
@Defaults({
  birth_year: '',
  birth_month: '',
  birth_day: '',
  urlRoot: `${entryScriptName}/api/v3/user`,
})
export class User extends Model {
  /**
   * Парсит дату рождения пользователя
   */
  parseDate () {
    let dateAr
    const birthDate = this.get('birth_date')

    if (!birthDate) {
      return
    }

    dateAr = birthDate.split('-')

    this.birth_year = dateAr[0]
    this.birth_month = dateAr[1]
    this.birth_day = dateAr[2]
  }

  /**
   * Сохранение айди организатора СП
   * @param {number} organizerId
   * @param {Object} options опции запроса на сохранение
   */
  saveJpOrganizer (organizerId, options) {
    setCookie('my_jp_organizer', organizerId, {
      expires: moment().add(1, 'hours').toString(),
      path: '/',
    })

    if (this.get('id')) {
      const newUserData = {
        selected_jp_organizer_id: organizerId,
      }
      if (options && !options.error) {
        options.error = () => {
          globalValidationError([{
            message: '',
          }], 'При сохранении выбранного организатора совместной покупки')
        }
      }

      this.save(newUserData, options)
    } else if (options && isFunction(options.success)) {
      options.success(this, null, options)
    }
  }

  /**
   * Список приложений (messengers) привязанных к телефону.
   * @returns {Array}
   */
  phoneApps () {
    let apps = []
    if (this.get('phone')) {
      this.get('is_whatsapp') && apps.push('WhatsApp')
      this.get('is_viber') && apps.push('Viber')
      this.get('is_telegram') && apps.push('Telegram')
    }

    return apps
  }

  /**
   * Номер телефона в человекочитаемом формате.
   * @returns {*|string}
   */
  phoneHumanFormat () {
    return getFormattedPhoneNumber(this.get('phone'))
  }
}
